import React from 'react'
import cn from 'classnames'

import './ActionButton.scss'

export const ActionButton = ({
  label,
  green,
  blue,
  yellow,
  disabled,
  onClick,
}) => {
  return (
    <button
      className={cn( 'market-action-button', { green }, { blue }, { yellow } )}
      disabled={ disabled }
      onClick={ onClick }
    >
      { label }
    </button>
  )
}